import { Card } from '@/components/ui/card.component';
import { Markdown } from '@/components/ui/markdown/markdown.component';

interface IndexPostProps {
  post: string;
}

export function IndexPost({ post }: IndexPostProps) {
  return (
    <div className="mt-10 mb-6">
      <Card className="border-0 shadow-none p-0 bg-gray-50 md:border md:shadow-tooltip md:bg-white md:pt-5 md:px-6">
        <Markdown content={post} />
      </Card>
    </div>
  );
}
